import { useRepository } from 'hooks/auth'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'

export const KillSwitchEnabledPage = observer(function KillSwitchEnabledPage() {
  const repository = useRepository()
  const killSwitch = repository.killSwitch
  const { t, tt } = useTranslationTyped()
  const url = 'https://status.breakoutlearning.com'
  return (
    <div className="fixed flex h-screen w-screen flex-col items-center justify-center">
      <img
        src="/assets/images/logo.png"
        width={64}
        alt={t('breakout_learning')}
      />
      <div className="mt-4 text-headline-large">
        {tt.kill_switch_enabled.title()}
      </div>

      {killSwitch.reason && (
        <div className="mt-4 text-center">
          <div className="text-label-large">
            {tt.kill_switch_enabled.reason()}
          </div>
          <div className="mt-4 whitespace-pre-line rounded-2xl bg-core-tertiary p-6 text-body-large">
            {killSwitch.reason.replaceAll('\\n', '\n')}
          </div>
        </div>
      )}
      <div className="mt-4 text-label-large">
        {tt.kill_switch_enabled.visit()}
        <a className="underline" href={url} target="_blank" rel="noreferrer">
          {url}
        </a>
        {tt.kill_switch_enabled.more_details()}
      </div>
    </div>
  )
})
